import gql from "graphql-tag";

const VALUES_FILTERS_QUERY = gql`
  query filters($intanceID: ID!, $lang: String!) {
    filtersByInstance(instanceId: $intanceID, lang: $lang)
  }
`;

export default VALUES_FILTERS_QUERY;